export const DragTypes = Object.freeze({
  CARD: 'card',
  SCRATCHPAD_ITEM: 'scratchpad_item',
  EMPTY_LANE_CARD_TARGET: 'empty_lane_card_target',
  BOARD_LANE: 'board_lane'
});
